import { parsePhoneNumberFromString } from 'libphonenumber-js'
import * as Yup from 'yup'

import { PHONE_INTERNATIONAL_FORMAT_SYMBOL } from '../../../../../constants/common'

import { LOGIN_FORM_PHONE_VERIFICATION_FIELD_NAME_CODE } from './LoginFormPhoneVerification.constants'

export function toPrivatePhoneNumber(phone) {
  if (phone) {
    const parsedPhone = parsePhoneNumberFromString(`+${phone}`)

    if (parsedPhone) {
      const countryCode =
        PHONE_INTERNATIONAL_FORMAT_SYMBOL + parsedPhone.countryCallingCode
      const phoneNumber = parsedPhone.nationalNumber
      const phoneNumberLastTwoDigits = phoneNumber.slice(-2)

      const maskedDigits = phoneNumber.slice(0, -2).replace(/\d/g, '*')

      return `${countryCode} ${maskedDigits}${phoneNumberLastTwoDigits}`
    }
  }

  return phone
}

export function getLoginFormPhoneVerificationValidationSchema() {
  return Yup.object({
    [LOGIN_FORM_PHONE_VERIFICATION_FIELD_NAME_CODE]:
      Yup.string().required(true),
  })
}
